import { format } from "date-fns";

const custonEventM = (evento: any) => {
  let inicio = format(new Date(evento.event.start), "HH:mm");
  return <h6 className="eventoMes">{`${inicio} - ${evento.title}`}</h6>;
};

export default custonEventM;
